import { createContext } from 'react';

const LevelContextP07 = createContext(1);

export { LevelContextP07 };
